import { Tag, Text } from "@chakra-ui/react";

interface Props {
  label?: string;
  // "inline" sits in normal flow (next to a title); the others overlay a card corner.
  placement?: "top-right" | "top-left" | "inline";
}

const cornerProps = (placement: Props["placement"]) =>
  placement === "inline"
    ? {}
    : {
        pos: "absolute" as const,
        top: 3,
        zIndex: 2,
        ...(placement === "top-left" ? { left: 3 } : { right: 3 }),
      };

const DiscontinuedBadge = ({
  label = "Discontinued",
  placement = "top-right",
}: Props) => (
  <Tag
    {...cornerProps(placement)}
    flexShrink={0}
    // Card surfaces greyscale their whole subtree, so a coloured chip would render
    // as grey mush here. The dark chip stays legible; the yellow badge is used on
    // the nav surfaces, which are not greyscaled.
    bg="#142528"
    color="white"
    minH="auto"
    py="3px"
    px="8px"
    borderRadius="full"
    boxShadow="0 2px 8px rgba(20, 37, 40, 0.16)"
  >
    <Text
      fontSize="9px"
      fontWeight={700}
      letterSpacing="0.6px"
      lineHeight="1"
      textTransform="uppercase"
    >
      {label}
    </Text>
  </Tag>
);

export default DiscontinuedBadge;
